/** ***
------------------------------------------------------------------------
SEARCH RETURN PROPERTIES
------------------------------------------------------------------------
  agentId: "347"
  argsAddr: "null"
  argsElevatedLogonId: -9223372036854776000
  argsHostName: "null"
  argsLogonId: -9223372036854776000
  argsPort: -2147483648
  argsScript: "null"
  argsServiceImagePath: "null"
  argsServiceName: "null"
  destAddr: "null"
  destPort: -1
  edgeName: "ImageLoad"
  edgeType: "LIBRARYLOAD"
  epochMinutes: 26649300
  externalDestAddr: "false"
  os: "Windows"
  ret: 0
  sourceAddr: "null"
  sourceArgv: "/device/harddiskvolume2/windows/system32/conhost.exe 0xffffffff -ForceV1"
  sourceAuditSessionId: "null"
  sourceBinaryName: "/device/harddiskvolume2/windows/system32/conhost.exe"
  sourceComm: "conhost.exe"
  sourceExefilehash: "f-83341706-281474976953515-1468675118551632700"
  sourceFamily: -1
  sourceGid: -1
  sourcePid: 568
  sourcePort: -1
  sourceProcessHash: "agent-347-p-568-1598958052757141400"
  sourceSessionId: 0
  sourceSid: "S-1-5-21-3830230163-3304086689-1256350077-296610"
  sourceUid: -1
  sourceWinSubjectDomain: "null"
  sourceWinSubjectUser: "null"
  sourceWinSubjectUserId: -1
  sourceWinTargetDomain: "null"
  sourceWinTargetUser: "null"
  sourceWinTargetUserId: -1
  targetArgv: "null"
  targetAuditSessionId: "null"
  targetBinaryName: "null"
  targetComm: "null"
  targetExefilehash: "null"
  targetFileGroup: -2147483648
  targetFileHash: "agent-347-f-83341706-1125899907168397-1581055746655348200"
  targetFileMode: -2147483648
  targetFileUser: -2147483648
  targetGid: -1
  targetPathName: "/device/harddiskvolume2/windows/system32/kernel.appcore.dll"
  targetPid: -1
  targetProcessHash: "null"
  targetSessionId: -1
  targetSid: "null"
  targetUid: -1
  timestampMillis: 1598958052778
  topLevelDomain: "null"
  trailId: "273425322"

** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const querySearchMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'expand',
        display: 'multicolumn',
        description: 'Long Fields',
        label: 'File Info',
        sortable: false,
        'min-width': 150,
        name: 'file',
        columns: [
          {
            datatype: 'string',
            description: 'Command Line',
            label: 'Command Line',
            name: 'sourceArgv'
          },
          {
            datatype: 'string',
            description: 'Binary Path',
            label: 'Binary Path',
            name: 'sourceBinaryName'
          },
          {
            datatype: 'string',
            description: 'Source Container Id',
            label: 'Source Container',
            name: 'sourceContainerId'
          },
          {
            datatype: 'string',
            description: 'Source Container Image Id',
            label: 'Source Container Image',
            name: 'sourceContainerImageId'
          },
          {
            datatype: 'string',
            description: 'Target Container Id',
            label: 'Target Container',
            name: 'targetContainerId'
          },
          {
            datatype: 'string',
            description: 'Target Container Image Id',
            label: 'Target Container Image',
            name: 'targetContainerImageId'
          },
          {
            datatype: 'string',
            description: 'Target File Path',
            label: 'Target File Path',
            name: 'targetPathName'
          }
        ]
      },
      {
        datatype: 'string',
        display: 'multicolumn',
        description: 'Timestamp',
        label: 'Common Fields',
        sortable: false,
        fixed: 'left',
        'min-width': 150,
        name: 'common',
        columns: [
          {
            datatype: 'string',
            description: 'Event Type',
            label: '',
            name: 'edgeName'
          },
          {
            datatype: 'string',
            description: 'Local Trail ID',
            label: 'Local TrailId ID',
            name: 'trailId'
          },
          {
            datatype: 'string',
            conditional: true,
            description: 'Host',
            label: 'Host',
            name: ['hostname', 'agentId']
          },
          {
            datatype: 'datetime',
            format: DATETIME_FORMAT,
            description: 'Timestamp',
            label: 'Timestamp',
            name: 'timestampMillis'
          }
        ]
      },
      {
        datatype: 'string',
        display: 'multicolumn',
        description: 'Process',
        label: 'Process',
        fixed: 'left',
        sortable: false,
        'min-width': 150,
        name: 'process',
        columns: [
          {
            datatype: 'string',
            description: 'Process ID',
            label: 'Pid',
            name: 'sourcePid'
          },
          {
            datatype: 'string',
            description: 'Program',
            label: 'Program',
            name: 'sourceComm'
          },
          {
            datatype: 'string',
            description: 'Parent Pid',
            label: 'Parent Pid',
            name: 'sourcePpid'
          },
          {
            datatype: 'string',
            description: 'Parent Program',
            label: 'Parent Program',
            name: 'parentComm'
          }
        ]
      },
      {
        datatype: 'string',
        display: 'multicolumn',
        description: 'Agent ID',
        label: 'User Info',
        sortable: false,
        fixed: 'right',
        'min-width': 150,
        name: 'user',
        columns: [
          {
            datatype: 'string',
            description: 'Name',
            label: 'Username',
            name: 'sourceWinTargetUser'
          },
          {
            datatype: 'string',
            description: 'SID',
            label: 'SID',
            name: 'sourceSid'
          },
          {
            datatype: 'string',
            description: 'Login Id',
            label: 'Login ID',
            name: 'logonId'
          },
          {
            datatype: 'string',
            description: 'Session ID',
            label: 'Session ID',
            name: 'auditSessionId'
          },
          {
            datatype: 'string',
            description: 'Authentication Result',
            label: 'Authentication Result',
            name: 'authenticationResult'
          }
        ]
      },
      {
        datatype: 'string',
        display: 'multicolumn',
        description: 'Agent ID',
        label: 'Network Info',
        fixed: 'right',
        sortable: false,
        'min-width': 150,
        name: 'network',
        columns: [
          {
            datatype: 'string',
            description: 'Source IP',
            label: 'Source IP',
            name: 'sourceAddr'
          },
          {
            datatype: 'string',
            description: 'Source Port',
            label: 'Source Port',
            name: 'sourcePort'
          },
          {
            datatype: 'string',
            description: 'Dest IP',
            label: 'Dest IP',
            name: 'destAddr'
          },
          {
            datatype: 'string',
            description: 'Dest Port',
            label: 'Dest Port',
            name: 'destPort'
          },
          {
            datatype: 'string',
            description: 'DNS Query',
            label: 'DNS',
            name: 'argsHostName'
          }
        ]
      }
    ]
  }
}

const searchNetworkColumn = {
  datatype: 'string',
  display: 'multicolumn',
  description: 'Agent ID',
  label: 'Network Info',
  fixed: 'right',
  sortable: false,
  'min-width': 150,
  name: 'network',
  columns: [
    {
      datatype: 'string',
      description: 'Source IP',
      label: 'Source IP',
      name: 'sourceAddr'
    },
    {
      datatype: 'string',
      description: 'Source Port',
      label: 'Source Port',
      name: 'sourcePort'
    },
    {
      datatype: 'string',
      description: 'Dest IP',
      label: 'Dest IP',
      name: 'destAddr'
    },
    {
      datatype: 'string',
      description: 'Dest Port',
      label: 'Dest Port',
      name: 'destPort'
    },
    {
      datatype: 'string',
      description: 'DNS Query',
      label: 'DNS',
      name: 'argsHostName'
    }
  ]
}

const searchUserColumn = {
  datatype: 'string',
  display: 'multicolumn',
  description: 'Agent ID',
  label: 'User Info',
  sortable: false,
  fixed: 'right',
  'min-width': 150,
  name: 'user',
  columns: [
    {
      datatype: 'string',
      description: 'Name',
      label: 'Username',
      name: 'sourceWinTargetUser'
    },
    {
      datatype: 'string',
      description: 'SID',
      label: 'SID',
      name: 'sourceSid'
    },
    {
      datatype: 'string',
      description: 'Login Id',
      label: 'Login ID',
      name: 'logonId'
    },
    {
      datatype: 'string',
      description: 'Session ID',
      label: 'Session ID',
      name: 'auditSessionId'
    }
  ]
}

export { querySearchMetaInfo, searchNetworkColumn, searchUserColumn }



// WEBPACK FOOTER //
// ./src/column-header/query_search/query-search-meta.js